import { PieChart } from "@mui/x-charts";
import React, { useEffect, useState } from "react";

const TaskPieChart = ({ dataPie, labelChart }) => {
  const [dataObj, setDataObj] = useState([]);

  useEffect(() => {
    if (dataPie) {
      setDataObj(dataPie);
    }
  }, [dataPie]);

  const handlecolorPie = () => {
    if (labelChart === "Capacità Operativa") {
      return [
        { id: 0, color: "#9b0b0b" },
        { id: 1, color: "#d8b207" },
      ];
    } else if (labelChart === "User") {
      return [
        { id: 0, color: "#C1272D" },
        { id: 1, color: "#359F1C" },
      ];
    } else {
      return [
        { id: 0, color: "#9572a2" },
        { id: 1, color: "#7f7f7f" },
      ];
    }
  };

  const dataPieWithColor = dataObj?.map((item, i) => {
    if (labelChart === "Stato Attività") {
      return {
        id: i,
        label: item.name,
        value: item.percentage,
      };
    } else {
      const series = handlecolorPie().find((s) => s.id === i);

      return {
        id: i,
        label: item.name,
        value: item.percentage,
        color: series?.color,
      };
    }
  });

  return (
    <div>
      <div className=" w-full flex justify-center items-center">
        <div
          style={{
            height: "600px",
          }}
          className="w-full flex justify-center items-center"
        >
          <PieChart
            series={[
              {
                data: dataPieWithColor,
                // cx: 150,
                arcLabel: "value",
              },
            ]}
            height={380}
            legend={{ hidden: true }}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskPieChart;
